/**
 * 1stdibs
 * User: James
 * Date: 11/7/13
 */
(function (root, factory) {
    "use strict";

    var m;
    if (typeof module !== 'undefined') {
        m = module;
        // CommonJS
        factory(m, require('dibs-backbone'), require('underscore'));
    } else {
        m = {};
        // Browser globals
        factory(m, root.Backbone, root._);
        //no need to export as it should attach itself to BaseView
    }

    // Attach to bunsen for non-CommonJS
    root.bunsen = root.bunsen || {};
    root.bunsen.marinate = m.exports;

}(typeof window !== 'undefined' ? window : global, function (module, Backbone, _) {
    // Define Module
    "use strict";

    var marinate;
    var _slice = Array.prototype.slice;
    var _randZeroPadding = 1000000000;
    var getFunc = function (obj, func) {
        if (typeof func === 'function') {
            return func;
        }
        if (typeof func === 'string') {
            return obj[func];
        }
        return undefined;
    };
    var addEventNamespace = function (eventKey, namespace) {
        var splitKey = eventKey.split(' ');
        eventKey = splitKey[0] + ('.' + namespace);
        eventKey += (splitKey[1] ? ' ' + splitKey[1] : '');
        return eventKey;
    };
    var _addEvents = function (view, name, eventsObj) {
        var key;
        var val;
        var areNamespaced = false;
        view.addedEvents = view.addedEvents || {};
        if (typeof name !== 'string') {
            eventsObj = name;
            name = false;
        }
        for (key in eventsObj) {
            if (eventsObj.hasOwnProperty(key)) {
                val = eventsObj[key];
                areNamespaced = (!_.isString(val) && !_.isFunction(val));
                break;
            }
        }
        if (areNamespaced) {
            _.extend(view.addedEvents, eventsObj);
        } else {
            view.addedEvents[name || _.size(view.addedEvents)] = eventsObj;
        }
        return view;
    };
    var _marinate = function (view, args) {
        _.each(args, function (mixin) {
            if (mixin.addedEvents) {
                _addEvents(view, mixin.addedEvents);
            }
            _.extend(view, _.omit(mixin, 'addedEvents'));
        });
        return view;
    };

    _.extend(Backbone.BaseView.prototype, {
        addEvents : function (name, events) {
            _addEvents(this, name, events);
            return this;
        },
        removeAddedEvents : function (name, undelegate) {
            delete this.addedEvents[name];
            if (undelegate) {
                this.$el.off('.' + name);
            }
            return this;
        },
        marinate: function () {
            _marinate(this, Array.prototype.slice.call(arguments));
            return this;
        }
    });


    /**
     * Overrides delegateEvents, only changing behavior if the view
     * instance has an 'addedEvents' property defined. This will
     * create an events object that has all events from the '.events'
     * property and the 'addedEvents' property. Added events
     * should be namespaced on a key (or autonamespaced).
     *
     * @override
     * @memberof Backbone.BaseView#
     * @param {object} [events]
     *      If provided, these will be used as the events instead of
     *      the events found in the events and addedEvents object
     * @param {boolean} [includeAdded]
     *      If true, and an events object is passed as a first param
     *      then instead of only using delegating events passed in
     *      as the first param, the events stored in the 'addedEvents'
     *      property are also delegated
     * @returns {Backbone.BaseView}
     */
    Backbone.BaseView.prototype.delegateEvents = function (events, includeAdded) {
        if ((!events || includeAdded) && this.addedEvents) {
            events = _.clone(_.result(this, 'events')) || {};
            var groupName;
            var eventKey;
            var callback;
            var addedEvents;
            var splitKey;

            for (groupName in this.addedEvents) {
                if (this.addedEvents.hasOwnProperty(groupName)) {
                    addedEvents = _.result(this.addedEvents, groupName);
                    for (eventKey in addedEvents) {
                        if (addedEvents.hasOwnProperty(eventKey)) {
                            if (!events[eventKey] || getFunc(this, events[eventKey]) !== getFunc(this, addedEvents[eventKey])) {
                                callback = addedEvents[eventKey];
                                if (isNaN(parseInt(groupName, 10))) {
                                    eventKey = addEventNamespace(eventKey, groupName);
                                }
                                if (!events[eventKey]) {
                                    events[eventKey] = callback;
                                } else {
                                    splitKey = eventKey.split(' ');
                                    eventKey = addEventNamespace(eventKey, ('dibs' + Math.round(Math.random() * _randZeroPadding)));
                                    events[eventKey] = callback;
                                }
                            }
                        }
                    }
                }
            }
        }
        return Backbone.BaseView.__super__.delegateEvents.call(this, events);
    };

    /**
     *
     * Slowly impart flavor into your BaseView instances. Also,
     * adds properties and methods your BaseView extension's
     * prototype like _.extend(MyView.prototype, mixin) would,
     * except that it looks for an 'addedEvents' property on
     * your mixin and adds those events to existing 'addedEvents'
     * rather than overwriting them.
     * @module {function} marinate
     * @param {...object} mixins
     *      One or more mixins to copy onto your view's prototype,
     *      with the optional 'addedEvents' object being added
     *      onto the existing addedEvents object instead of
     * @returns {function}
     */
    marinate = module.exports = function (View) {
        console.assert(View.prototype instanceof Backbone.BaseView, 'View must a Backbone.BaseView constructor');
        var mixins = _slice.call(arguments, 1);
        _marinate(View.prototype, mixins);
    };

    _.extend(marinate, {
        /**
         * Marinate only an instance of a view
         * @memberOf module:marinate
         * @param {Backbone.BaseView} viewInstance
         * @param {...object} mixins
         */
        marinateInstance: function (viewInstance) {
            console.assert(viewInstance instanceof Backbone.BaseView, 'viewInstance must be an instance of Backbone.BaseView');
            var mixins = _slice.call(arguments, 1);
            _marinate(viewInstance, mixins);
        },
        /**
         * Add DOM events to a BaseView pseudoclass
         * @memberOf module:marinate
         * @param {function} View Constructor for Backbone.BaseView
         * @param {string} name Namespace for your added events
         * @param {object} eventsObj Backbone DOM events hash
         */
        addProtoEvents: function (View, name, eventsObj) {
            console.assert(View.prototype instanceof Backbone.BaseView, 'View must a Backbone.BaseView constructor');
            _addEvents(View.prototype, name, eventsObj);
        },
        /**
         * Add DOM events to a BaseView instance
         * @memberOf module:marinate
         * @param {Backbone.BaseView} viewInstance
         * @param {string} name Namespace for your added events
         * @param {object} eventsObj Backbone DOM events hash
         */
        addEvents: function (viewInstance, name, eventsObj) {
            console.assert(viewInstance instanceof Backbone.BaseView, 'viewInstance must be an instance of Backbone.BaseView');
            _addEvents(viewInstance, name, eventsObj);
        }
    });

}));



//////////////////
// WEBPACK FOOTER
// ./~/dibs-baseview-marinate/index.js
// module id = 320
// module chunks = 63